import {useDispatch,useSelector} from 'react-redux'
import Modal from 'react-bootstrap/Modal'
import Dropdown from 'react-bootstrap/Dropdown'
import { getGenericAutomation, selectAllGenericAutomation} from '../users/usersSlice'
import {disableOnboarding} from '../../state/onboarding'
import { useEffect } from 'react'
import { envAwarePost,ellipsis,dateToAPIStandard } from '../../util/util'
import { useState } from 'react'
import './Onboarding.css';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Button from 'react-bootstrap/esm/Button';
import {
	getActivePrograms,  
	getSelectablePrograms,  
	selectAllSelectablePrograms, 
	enrollInProgram, 
	selectAllCategories, 
	getProgramCategories, 
	applyOnBoarding 
} from '../programs/programsSlice'
import Table from 'react-bootstrap/Table'
import Alert from 'react-bootstrap/Alert'
import DatePicker from "react-datepicker"
import Popover from 'react-bootstrap/esm/Popover'
import Form from 'react-bootstrap/Form'
import Spinner from 'react-bootstrap/esm/Spinner'
import { Col,Row,Container } from 'react-bootstrap'
import useOnboarding from '../../hooks/useOnboarding'
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch'
import { getTodaysEvents } from '../todaysEvents/TodaysEventsSlice'

import Tooltip from 'react-bootstrap/Tooltip'

import useCurrentUser from '../../hooks/useCurrentUser'

import { updatePresentmentCurrency } from '../settings/settingsSlice'
import {getCurrencySymbol} from '../../util/intl'


import useCurrencySettings from '../../hooks/useCurrencySettings'

function TrainerOnboarding(){
	const dispatch = useDispatch()
	const { acceptedCurrency, acceptedCurrencies } = useCurrencySettings()
	const handleUpdateCurrency = e => {
        const currency_id = e.target.value
        dispatch(updatePresentmentCurrency(currency_id))
    }
    function updateDatabase(system) {
        envAwarePost( 'api/user/api', {
            action: 'updateMeasurementSystem',
            system: system
        }).then( res => {
            console.log(res)
        }).catch( err => console.log(err) )
    }
	return (
		<div>
			<Alert variant="warning" className="text-dark my-2">
				<strong>Please review the important settings below</strong>
			</Alert>
			<div>
				<div>
					<i className="fa fa-info-circle mr-1"/>
					You can always change these later in settings
				</div>
				<div>
                    Currency:
                    <Form.Control
                        onChange={handleUpdateCurrency}
                        value={acceptedCurrency.id}
                        as="select"
                    >
                        {acceptedCurrencies.map( ac => (
                            <option key={ac.id} value={ac.id}>
                                {
                                    getCurrencySymbol(ac.ISO) === ac.ISO ?
                                    ac.ISO :
                                    `${getCurrencySymbol(ac.ISO)} ${ac.ISO}`
                                }
                            </option>
                        ))}
                    </Form.Control>
                    <small className="d-block text-info">
                        Don't see your currency? contact 
                        <a 
                            className="ml-1"
                            href="mailto:support@fitsw.com?subject=Please Add My Currency"
                        >
                            support@fitsw.com
                        </a>
                        
                    </small>
                </div>
				<div>
                    <Form.Label className="col-form-label">
                        Units of Measure
                    </Form.Label>
                    <Form.Control
                        className="form-control-alternative"
                        name="measurementSystem" 
                        as="select"
                        onChange={(e) => {
                            updateDatabase(e.target.value)
                        }}
                    >
                    	<option value="imperial"> Imperial </option>
                        <option value="metric"> Metric System  </option>
                    </Form.Control>
				</div>
			</div>
		</div>
	)
}


const FirstLogin = ({youtube_id})=>{
	const dispatch = useDispatch()
	const user = useCurrentUser()
	const isOwner = (
		parseInt(user.gym_id) !== 0 
		? user.account_type === 'gym'
		: user.account_type === 'trainer'
	)
	if(youtube_id !== ""){
		return(
		<div>
			<p className="text-center">
				<strong>Welcome to FitSW</strong>
			</p>
			<div style={{
				width:'100%',
				paddingTop:'56.25%',
				position:'relative',
				overflow:'hidden'
			}}>
				<iframe 
					style={{
						position:'absolute',
						top:0,
						left:0,
						border:'none'
					}}
					title="welcome video"
					width="100%"
					height="100%"
					src={`https://www.youtube.com/embed/${youtube_id}`}
				/>
			</div>
			{isOwner&&<TrainerOnboarding/>}
		</div>
		)
	} else {
		dispatch(disableOnboarding())
		return (
			<>
			</>
		)
	}

}

const GenericProgramAutomation = ({categories, handleClose})=>{
	const dispatch = useDispatch()
	//set up initial state for onboarding data to 
	//apply
	const initOnboardingResultMap = {}
	categories.forEach(c=>{
		initOnboardingResultMap[c.name] = "choose"
	})
	const [onboardingResultMap,setOnboardingResultMap] = useState(initOnboardingResultMap)
	// options || assign
	const statusDispatch = useApiStatusDispatch()
	const [loading, setLoading] = useState(false);
	const [mode,setMode] = useState('options')
	const [programs,setPrograms] = useState([])
	const [showEnrollModal,setShowEnrollModal] = useState(false)
	const [enrollDate,setEnrollDate] = useState(new Date())
	const [programToAssign,setProgramToAssign] = useState(null)
	const [programTitle, setProgramTitle] = useState("");

	const handleApplyOnboarding = ()=>{
		const onboardingResult = Object.values(onboardingResultMap).filter(r=>r!=='choose')
		if (onboardingResult.length === 0) {
			alert("Please select at least one option")
			return
		}
		console.log(onboardingResult)
		envAwarePost('api/programs/api/',{
			action:'applyOnboarding',
			onboarding_result:onboardingResult
		}).then(res=>{
			const {success,message,data} = res
			if(success === '1'){
				if(res.data.status === 'no_matches'){
					alert('Sorry, no programs matched these options.')
				}else{
					setMode('assign')
					setPrograms(data.programs)
				}
			}else{
				alert(message)
			}
		})
	}
	const modeComponentMap = {
		'options':(
			<div>
				<p className="text-center">
					<strong>Please choose the option(s) that best suit you</strong>
				</p>
				<Container>
					{categories.map(c=>(
						<Row className="mb-2">
							<Col xs={2}>
								<label>{c.name}:</label>
							</Col>
							<Col>
								<Form.Control 
									value={onboardingResultMap[c.name]}
									onChange={e=>{
										setOnboardingResultMap(prev=>(
											{
												...prev,
												[c.name]:e.target.value
											}
										))
									}}
									as="select" 
									custom
								>
									<option value="choose">Choose {c.name}</option>
									{c.options.map(o=>(
										<option value={o.id}>{o.name}</option>
									))}
								</Form.Control>
							</Col>
						</Row>
					))}
					<Row>
						<Col>
							<Button block variant="outline-success" onClick={handleApplyOnboarding}>
								See Applicable Health/Fitness Programs
							</Button>
						</Col>
					</Row>
				</Container>
			</div>
		),
		'assign':(
			<div>
				<Button onClick={()=>setMode('options')} variant="outline-info" block>
					Select new program options
				</Button>
				<Table striped bordered hover className="mt-2">
					<tbody>
						{programs.map(p=>(
							<tr>
								<td>
									<div className="d-flex align-items-center justify-content-between">
										<div>
											<div>{p.programName}</div>
											<div>{ellipsis(p.programNotes,80)}</div>
										</div>
										<Button 
											onClick={()=>{
												setProgramTitle(p.programName)
												setProgramToAssign(p.programID)
												setShowEnrollModal(true)
											}}
											variant="outline-primary" 
											size="sm">
											Enroll
										</Button>
									</div>
								</td>
							</tr>
						))}
					</tbody>
				</Table>
			</div>
		)
	}
	return (
		<div>
			{modeComponentMap[mode]}
			<Modal centered show={showEnrollModal} onHide={()=>setShowEnrollModal(false)}>
				<Modal.Header closeButton>
					When would you like to start?
				</Modal.Header>
				<Modal.Body>
					<label> Pick a date: 
						<DatePicker 
							selected={enrollDate}
							onChange={(date)=>{
								setEnrollDate(new Date(date))
							}}
							className="m-1" 
							placeholder="subscribe"/>
					</label>
				</Modal.Body>

				<Modal.Footer>
					<Button 
						onClick={()=>{
							setLoading(true);
							statusDispatch(enrollInProgram({
								start_date:dateToAPIStandard(enrollDate).split(' ')[0],
								program_id:programToAssign
							}), "program", "enroll")
							.then(()=>{
								setLoading(false);
								setShowEnrollModal(false)
								handleClose();
								setEnrollDate(new Date())
								dispatch(getTodaysEvents())
							})
							
						}}
						disabled={!Boolean(enrollDate)} 
						variant={Boolean(enrollDate)?"outline-success":"outline-secondary"}>
						{loading ? 	<Spinner animation="border" size="sm"/> : Boolean(enrollDate)?"Enroll Now":"Choose Date"}
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	)
}

const Onboarding = () => {
	const dispatch = useDispatch()
	const onboardingSteps = useOnboarding()
	const [currentStep,setCurrentStep] = useState(0)
	const show = onboardingSteps.length > 0

	console.log(onboardingSteps)

	const handleClose = ()=>{
		//disable automations
		dispatch(disableOnboarding())
		//reset onboarding to initial step
		setCurrentStep(0)
	}
	const resolveComponent = (stepData)=>{
		console.log('stepData: ', stepData)
		switch(stepData.type){
			case "first_login": 
				return <FirstLogin youtube_id={stepData.youtube_id}/>
			case "generic_program_automation": 
				return <GenericProgramAutomation handleClose={handleClose} categories={stepData.categories}/>
		}
	}
	const prev = ()=>{
		setCurrentStep(Math.max(0,currentStep-1))
	}
	const stepText = (offset)=>{
		const offsetStepType = onboardingSteps[currentStep+offset].type
		const typeTextMap = {
			'generic_program_automation':'Enroll In a Health/Fitness Program',
			'first_login':'Get To Know the FitSW App'
		}
		return typeTextMap[offsetStepType]
		
	}
	const next = ()=>{
		setCurrentStep(Math.min(onboardingSteps.length-1,currentStep+1))
	}
	const prevText = ()=>stepText(-1)
	const nextText = ()=>stepText(1)
	if(!show) return null
	return (
		<Modal size="lg" show={show} onHide={()=>{}} centered>
			{onboardingSteps.length > 1 &&
				<Modal.Header>
						{
							currentStep > 0  &&
							<Button variant="outline-primary" size="sm" onClick={prev}>
								<i className="fas fa-arrow-left"/> {prevText()}
							</Button>
						}
						{
							currentStep<onboardingSteps.length-1 && 
							<Button variant="outline-primary" className="ml-auto" size="sm" onClick={next}>
								{nextText()} <i className="fas fa-arrow-right"/> 
							</Button>
						}
				</Modal.Header>
			}
			<Modal.Body>
				<div>
					{resolveComponent(onboardingSteps[currentStep])}
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button block variant="outline-primary" onClick={handleClose}>
					Skip
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default Onboarding